export default "__VITE_ASSET__BZIg3b7G__"